/**
 * Created by Ricardo Manzano on 29/11/2021.
 */
import mediaGeneral from '@/store/modules/media/general';

export default {
  mediaGeneral,
};
